<!-- eslint-disable prettier/prettier -->
<ng-container *ngIf="!isUserLoggedIn"><app-ehe-header></app-ehe-header> </ng-container>
<ng-container *ngIf="isUserLoggedIn"><app-ehe-header [auth]="true"></app-ehe-header> </ng-container>
<section class="static-content-wrapper general-wrapper">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="title-container">
					<h3><u>TERMS AND CONDITIONS OF USE</u></h3>
				</div>
				<div class="group">
					<p>
						Your use of Life Extension Institute, LLC d/b/a EHE Health's ("EHE Health") website www.my.ehe.health (the
						"Web Site" or "myEHE") are subject to the following terms and conditions of use ("Terms and Conditions").
						PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS WEB SITE.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">ACCEPTANCE OF TERMS</p>
					<p>
						Your use of this Web Site are expressly conditioned on your acceptance of the following Terms and
						Conditions, including our Data Privacy Policy (posted at
						<a href="https://my.ehe.health/privacy-policy">https://my.ehe.health/privacy-policy</a>) and Notice of
						Privacy Practices (posted at
						<a href="https://my.ehe.health/notice-of-privacy-practices"
							>https://my.ehe.health/notice-of-privacy-practices</a
						>) which describe our collection, use, and disclosure of information about you. This Web Site is for
						educational purposes and also can store and transmit data to those who you designate. BY USING THIS WEB
						SITE, YOU SIGNIFY YOUR ASSENT TO BE BOUND BY THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO THESE TERMS
						AND CONDITIONS, YOU MUST NOT USE MYEHE OR THE COACHING SERVICES. YOU HEREBY CERTIFY THAT YOU HAVE RECEIVED
						AND REVIEWED THE DATA PRIVACY POLICY AND NOTICE OF PRIVACY PRACTICES WHICH DESCRIBE THE TYPES OF USES AND
						DISCLOSURE OF YOUR PERSONAL INFORMATION AND EHE HEALTH'S OBLIGATIONS IN CONNECTION TO YOUR PERSONAL
						INFORMATION, AMONG OTHER INFORMATION OR DATA.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">ACCESS</p>
					<p>
						You acknowledge and agree that you are responsible for obtaining and maintaining all telecommunications,
						broadband, and computer hardware, equipment and services needed to access and use the Web Site, and for
						paying all charges related thereto. We do not operate or control the Internet or your connection, so we
						cannot and do not warrant, make any representations concerning or guarantee that the Web Site will be error
						or virus free, invulnerable to hackers or other unauthorized users, or always available.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">MODIFICATION</p>
					<p>
						EHE Health retains and reserves the right, in EHE Health's sole discretion, to revise these Terms and
						Conditions from time to time by updating this posting with the revised terms taking effect as of the date of
						its posting. It is your responsibility to review these Terms and Conditions every time you use this Web Site
						and its associated services, including Coaching, because the continued use of or access to the Web Site
						following modification constitutes acceptance that all of these terms are binding upon you.
					</p>
					<p>
						Furthermore, EHE Health may add, change or delete availability and functionality of the data, software and
						hardware and physical location of the hosting environment related to myEHE at its sole discretion in any
						way. You agree that these changes will occur at EHE Health's time of choice and you will not be given notice
						or the option to delay, refuse or prevent these changes to this service if you wish to continue using myEHE.
						If myEHE has a login feature, you may be prompted to electronically accept any revised agreements since the
						last time you logged in. You agree if you do not accept the changes, you will be denied access to further
						use of myEHE and related services described herein. You understand that the availability of any service,
						feature, data, database, or site content is subject to change or removal. EHE Health may impose limits or
						restrictions on access to part or all of the Web Site, the site content, or any other feature or service
						without notice or liability to EHE Health.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">VIRTUAL HEALTH COACHING SERVICES</p>
					<p>
						You hereby understand and agree that if you elect to receive health care coaching services ("Coaching") from
						health care coaches contracted with EHE Health (the "Health Coaches"), such Health Coaches will be located
						at sites remote from you to provide the Coaching to you. Coaching is a virtual service that may be accessed
						through the Web Site or myEHE. You understand that the virtual service is a mode of delivering Coaching, via
						communication technologies.
					</p>
					<p>
						In some cases, virtual visits may not be the most appropriate way for you to seek Coaching. For example,
						certain medical conditions may require an in-person procedure, more urgent attention or use of a health care
						provider other than the Health Coach.
					</p>
					<p>
						We may ask you a series of initial questions to help you determine whether a virtual visit is appropriate
						for you. Based on your responses to these questions, we may determine that a virtual visit may not be
						appropriate for the particular issue. In such a case: (i) your request for a virtual visit will not be
						submitted to the Health Coach; and (ii) you will be routed for either an in-person visit or emergency care.
					</p>
					<p>
						Additionally, the Health Coach may, following submission of a virtual visit request, determine that you
						require an in-person office visit. In such a case: (i) your request for a virtual visit will be cancelled;
						and (ii) you will be referred for either an in-person visit or emergency care.
					</p>
					<p>Virtual Coaching may have the following benefits:</p>
					<ul>
						<li>Make it easier and more efficient for you to seek Coaching.</li>
						<li>Permit you to seek Coaching at times that are convenient for you.</li>
						<li>Enable you to communicate with your Health Coach without the necessity of an in-office appointment.</li>
					</ul>
					<p>There are also potential risks of receiving Coaching, including, but not limited, to the following:</p>
					<ul>
						<li>You will not be in the same location or room as your Health Coach.</li>
						<li>
							There is potential for other people to overhear sessions if you are not in a private place during the
							session. On your end, you must take reasonable steps to ensure your privacy.
						</li>
						<li>Stored data could be accessed by unauthorized people or companies.</li>
						<li>
							There is no guarantee that virtual services are effective for all individuals, and therefore, results
							cannot be guaranteed.
						</li>
						<li>
							Your Health Coach's inability to conduct certain tests in-person may prevent the Health Coach from
							providing Coaching to you.
						</li>
						<li>
							Your Health Coach may not be able to provide Coaching for your particular needs and you may be required to
							seek alternative services from licensed health care professionals.
						</li>
						<li>
							The information transmitted to your Health Coach may not be sufficient to allow them to make an
							appropriate assessment.
						</li>
						<li>The quality of the transmitted data may affect the quality of the Coaching.</li>
						<li>
							The changes in the environment and test conditions could be impossible to make during the delivery of
							Coaching.
						</li>
					</ul>
				</div>
				<div class="group">
					<p class="sub-title">NOT MEDICAL ADVICE</p>
					<p>
						myEHE does not offer medical advice, and no medical advice is provided on the Web Site. Any content accessed
						through myEHE is for informational purposes only, and is not intended to cover all possible uses,
						directions, precautions, drug interactions, or adverse effects, nor to diagnose, cure, treat, mitigate, or
						prevent any disease or other medical condition. This content, nor the Coaching services, should be used
						during a medical emergency or for the diagnosis or treatment of any medical condition. You understand that
						personal health information should not be entered into the Web Site or provided in connection with your use
						of the Web Site. If such personal health information is provided, it will not be afforded confidential
						treatment or protection.
					</p>
					<p>
						You agree to consult your doctor or other qualified health care provider if you have any questions about a
						medical condition, or before taking any drug, changing your diet or commencing or discontinuing any course
						of treatment. Do not ignore or delay obtaining professional medical advice because of information accessed
						through myEHE or reliance on the Coaching services provided by Health Coaches. Call 911 or your doctor for
						all medical emergencies. You should not disregard professional medical advice or delay seeking care based on
						information found on this Web Site or information provided by the Health Coaches.
					</p>
					<p>
						EHE Health does not recommend or endorse any specific tests, products or procedures that may be mentioned on
						the Web Site. EHE Health does not assume any liability for the contents of any material or Coaching provided
						through the Web Site. Reliance on any information provided by EHE Health or the Health Coaches, is at your
						own risk. EHE Health assumes no liability or responsibility for damage or injury to persons or property
						arising from any use of any product, Coaching, information, idea or instruction referenced on the Web Site.
						EHE Health reserves the right to change or discontinue at any time any aspect or feature of the Web Site.
					</p>
					<p>
						Coaching is not intended to diagnose, treat, prevent or cure any disease or condition. It is not intended to
						substitute for the advice, treatment and/or diagnosis of a qualified licensed professional. Health Coaches
						may not make any medical diagnoses, claims and/or substitute for your licensed healthcare provider's care.
						Health Coaches do not provide second opinion or in any way attempt to alter the treatment plans or
						therapeutic goals/recommendations of your licensed healthcare providers. Coaching and any information on the
						myEHE website is for general informational purposes only. It must never be considered a substitute for
						advice provided by a doctor or other qualified healthcare professional. Always seek the advice of your
						physician or other qualified healthcare professional with questions you may have regarding your medical
						condition or any medical condition.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">USE OF myEHE</p>
					<p>
						You are responsible for the security of your passwords and for any use of your account. You must immediately
						notify myEHE of any unauthorized use of your password or account by sending an e-mail to the following
						address: <a href="mailto:EPMS_Support@ehe.health"> EPMS_Support&#64;ehe.health</a>.
					</p>
					<p>
						You cannot transfer any password, login information, or rights granted to you for using the Web Site or any
						service on the Web Site to any other person or entity. Any attempt to transfer any rights covered will be
						null and void. You may not transfer any appointments for Coaching to any other person. Any violation of this
						provision may result in the termination of all rights to access and use the Web Site.
					</p>
					<p>
						Your use of myEHE and any content or services accessed through myEHE, including Coaching, must comply with
						these Terms and Conditions and with all applicable laws, regulations and ordinances, including any laws
						regarding the export of data or software.
					</p>
					<p>
						You must be at least 18 years old to use myEHE. This Web Site is not intended for and should not be used by
						minors.
					</p>
					<p>
						You may not access myEHE other than by the interfaces provided by EHE Health or interfere with or disrupt
						the proper operation of myEHE.
					</p>
					<p>
						You hereby grant EHE Health a license to use and distribute any information about you collected by,
						transferred to, or otherwise within the possession of EHE Health, in connection with services provided on
						the Web Site. However, EHE Health may only use such information as permitted by applicable law.
					</p>
					<p>
						You hereby grant permission and consent to EHE Health using third-party vendors to update your personal
						information in EHE Health's system using publicly available data solely to ensure that your information on
						file with EHE Health is accurate and up-to-date.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">COMMUNICATIONS</p>
					<p>
						EHE Health utilizes calls, text messages, and email communications to enhance your engagement and ensure
						timely healthcare service management. By providing your contact information in the form provided on the
						website and checking the box therein, you expressly acknowledge that you are authorizing EHE Health to place
						commercial telephonic sales calls to you via telephone call, text message, or voicemail using an automated
						system for the selection or dialing of telephone number, the playing of a recorded message when the call is
						answered, or the transmission of a prerecorded voicemail, as further described in this section. You are not
						required to sign this agreement directly or indirectly or to agree to these terms as a condition of
						purchasing any property, goods, or services. This express consent includes appointment reminders, marketing
						communications, informational communications, promotional and business communications, and recurring
						communications for healthcare management or other business purposes of EHE Health.
					</p>
				</div>
				<div class="group">
					<p>
						<strong>Appointment Reminders</strong> - EHE Health may send calls, text messages, and emails to you of
						upcoming appointments to help you manage your healthcare schedule effectively. This may include reminders in
						connection to preventative care. For example, if you miss your annual appointment, EHE Health may send you a
						reminder that you are due for care.
					</p>
				</div>
				<div class="group">
					<p>
						<strong>Marketing Communications</strong> - With your explicit consent provided herein, EHE Health may send
						marketing communications through various channels, including but not limited to calls, text messages, direct
						mailers, and emails. These communications will inform you about new services, special offers, and
						health-related information that may be of interest to you.
					</p>
				</div>
				<div class="group">
					<p>
						<strong>Recurring Communications</strong> - EHE Health may send recurring communications to assist you in
						scheduling services, managing ongoing preventive healthcare including Coaching, and providing updates
						relevant to your healthcare.
					</p>
					<p>
						Enrollment in text alerts requires an individual to provide their own mobile phone number with an area code
						within the 50 United States or the District of Columbia or United States territories. Once you enroll, the
						frequency of text alerts we send to you will vary. EHE Health does not impose a separate charge for text
						alerts; however, your mobile carrier's message and data rates may apply depending on the terms and
						conditions of your mobile phone contract. You are solely responsible for all message and data charges that
						you incur. Please contact your mobile phone service provider about such charges.
					</p>
				</div>
				<div class="group">
					<p>
						<strong>Opt-Out of Calls</strong> - If you no longer wish to receive calls from EHE Health, you can opt out
						by informing EHE Health by written or verbal communication that you wish to be removed from EHE Health's
						call list or to add you to EHE Health's Do Not Call List. No additional calls will be made to your phone
						number unless you reactivate your enrollment.
					</p>
				</div>
				<div class="group">
					<p>
						<strong>Opt-Out of Text Alerts</strong> - If you no longer wish to receive text alerts from EHE Health, you
						can opt out at any time by replying "STOP" to any message received from EHE Health. You will no longer
						receive text messages from EHE Health after opting out, except for any confirmation or error messages as
						required by law. No additional text alerts will be sent unless you reactivate your enrollment. For questions
						about text alerts, text the word Help to 90896, or contact us at 1-800-362-8671.
					</p>
				</div>
				<div class="group">
					<p>
						<strong>Opt-Out of Marketing Emails</strong> - If you no longer wish to receive marketing communications
						from EHE Health via email, you may opt-out-by clicking the "Update My Email Preference" link at the bottom
						of our marketing emails and follow the prompts directed to you on the webpage. Opting out of marketing
						emails does not affect your continued receipt of appointment related email communications which are only
						sent out to you regarding your ongoing patient care with EHE Health. Please reach out to your healthcare
						provider for directions on how to opt out of your ongoing patient care e-mails.
					</p>

					<p>
						EHE Health reserves the right to update or modify these terms of use at any time without prior notice. Your
						continued use of EHE Health's communications program after any changes constitutes acceptance of those
						changes. EHE Health and its related companies and each of their respective officers, directors, and
						employees are not responsible and shall not be liable for any loss or injuries of any kind resulting,
						directly or indirectly, from any EHE Health communication program or from technical failures or delays of
						any kind. EHE Health reserves the right to cease delivery of text alerts to any person at any time in its
						sole discretion.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">THIRD-PARTY CONTENT AND SERVICES OFFERED THROUGH myEHE</p>
					<p>
						EHE Health may make third-party services available through the Web Site, including services by healthcare
						provider partners or Health Coaches on myEHE. EHE Health may screen, modify, refuse, or remove certain
						content or third-party services, but is not responsible for and does not endorse any third-party content or
						services. EHE Health further does not endorse any third-party service providers, other health care
						providers, products, services, opinions, or web sites accessed through myEHE. Your interaction and
						relationship with third parties is governed by the contractual relationship or terms of use with such
						parties. Notwithstanding the foregoing, you acknowledge, understand and agree that you may be required to
						agree to such terms of use to access and/or use such third-party content or services.
					</p>
					<p>
						USE OF THESE SERVICES AND RELIANCE ON THIS CONTENT IS SOLELY AT YOUR OWN RISK. EHE HEALTH MAY NOT BE HELD
						LIABLE FOR ANY DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF ANY THIRD-PARTY SERVICE OR CONTENT.
						Providers of these third-party services and/or content are EHE Health's "Licensors".
					</p>
				</div>
				<div class="group">
					<p class="sub-title">ONLINE MEDICAL RECORD</p>
					<p>
						EHE Health offers an online medical record service ("Online Medical Record"), consisting of medical records
						provided by your physician(s) and/or health care providers.
					</p>
					<p>
						YOU ARE SOLELY RESPONSIBLE FOR THE DISSEMINATION OF YOUR ONLINE MEDICAL RECORD. EHE HEALTH DOES NOT IN ANY
						WAY EDIT, REVIEW, SPONSOR, APPROVE, VERIFY, INVESTIGATE OR OTHERWISE ACKNOWLEDGE THE SUFFICIENCY OR
						COMPLETENESS OF ANY CONTENT PROVIDED IN YOUR ONLINE MEDICAL RECORD. LIKEWISE, EHE HEALTH DOES NOT IN ANY WAY
						AUTHORIZE, FACILITATE, OVERSEE, SPONSOR OR IN ANY WAY ASSIST OR PARTICIPATE IN THE DISTRIBUTION OF YOUR
						ONLINE MEDICAL RECORD. EHE HEALTH IS NOT LIABLE FOR ANY INACCURACY, OMISSION OR ERROR IN YOUR ONLINE MEDICAL
						RECORD. EHE HEALTH IS NOT LIABLE FOR THE ERRONEOUS DISSEMINATION OF YOUR ONLINE MEDICAL RECORD TO ANY
						THIRD-PARTY. DISSEMINATION OF YOUR ONLINE MEDICAL RECORD IS SOLELY YOUR RESPONSIBILITY.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">INTELLECTUAL PROPERTY</p>
					<p>
						You acknowledge, understand and agree that EHE Health has sole and exclusive ownership of all right, title
						and interest in and to any and all materials on the Web Site, including all designs and information,
						marketing images (including but not limited to trademarks and other logos), designs, plans and tools, and
						all other service, marketing and business-related information and data (collectively, the "Materials"). You
						further acknowledge, represent and warrant that you have not acquired, and shall not acquire, whether by
						operation of law, these Terms and Conditions, or otherwise, any right, title, interest, or other ownership
						in or to the Materials.
					</p>
					<p>
						You acknowledge, understand and agree that EHE Health has the sole and exclusive ownership of all right,
						title and interest in and to EHE Health's trademarks, and all registrations and applications therefore. You
						further acknowledge, represent and warrant that you have not acquired, and shall not acquire, whether by
						operation of law, exercise of rights under these Terms and Conditions, or otherwise, any right, title,
						interest, or other ownership in or to any trademarks which are protected by federal and state law in the
						United States and throughout the world and/or are displayed on the Web Site.
					</p>
					<p>
						When using this Web Site, EHE Health hereby grants you the non-exclusive, terminable, worldwide license
						pursuant to these Terms and Conditions to view and display the Materials for any lawful personal purpose.
						The nonexclusive license does not permit reproduction, republication, modification, distribution,
						publication, display, transmission, assignment, sublicense, sale, lease, creation of derivative works, or
						any other use. All other rights are reserved by EHE Health and are not included as part of this license. You
						agree that any violation of this provision will cause EHE Health immediate and irreparable harm,
						automatically entitling EHE Health to temporary or permanent injunctive relief, in addition to all other
						available legal and equitable remedies.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">DMCA NOTICE AND TAKEDOWN POLICY AND PROCEDURE</p>
					<p>
						To the extent applicable, we have established this DMCA Policy and Procedure in compliance with the Digital
						Millennium Copyright Act ("DMCA"). EHE Health respects the intellectual property rights of others and
						expects users of the Web Site to do so as well. In accordance with the provisions of the DMCA applicable to
						Internet service providers (17 U.S.C. Section 512), we have adopted a policy of taking down material that
						infringes upon the copyright rights of others and terminating, in appropriate circumstances and at our sole
						discretion, users, members, subscribers, or account holders who are deemed to be infringing upon the
						copyright rights of others. If you believe that your work has been copied in a way that constitutes
						copyright infringement or is being infringed upon in connection with any posting or site content uploaded to
						the Web Site, please provide us with the following information in writing to the designated Copyright Agent
						listed below:
					</p>
					<ol>
						<li>
							Identification (or description) of the copyrighted work or works that you claim have been infringed (or a
							representative list of such works);
						</li>
						<li>
							Identification (or description) of where the material that you claim is infringing upon your work can be
							found on the Web Site;
						</li>
						<li>Contact information for the copyright holder or its agent;</li>
						<li>
							A statement that you have a good-faith belief that the allegedly infringing material is not authorized by
							the copyright owner, its agent or the law;
						</li>
						<li>
							A statement by you under penalty of perjury that the above information in your notice is accurate and that
							you are the owner of the copyrighted work, that you are authorized to act on behalf of the owner of the
							copyrighted work, or that you are the owner of one of the exclusive rights under copyright law that is
							allegedly infringed; and
						</li>
						<li>A physical or electronic signature of the copyright holder or its agent.</li>
					</ol>
					<p>
						EHE Health reserves the right to remove any content or material posted to the Web Site in its sole
						discretion.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">RELEASE</p>
					<p>
						YOU HEREBY RELEASE AND FOREVER DISCHARGE FOR YOURSELF, YOUR HEIRS, EXECUTORS, ADMINISTRATORS AND ASSIGNEES,
						EHE HEALTH AND ITS AFFILIATES, EMPLOYEES, OWNERS, OFFICERS, DIRECTORS, AGENTS, AND REPRESENTATIVES, AS WELL
						AS THE COMPANY SPONSORING ANY RELATED EVENTS FROM ANY AND ALL CLAIMS, DEMANDS, ACTIONS AND CAUSES OF ACTION,
						WHICH MAY RESULT FROM YOUR PARTICIPATION AND USE OF myEHE. AS PARTIAL CONSIDERATION FOR THE SERVICES
						PROVIDED HEREUNDER, I HEREBY RELEASE EHE HEALTH AND ANY OTHER THIRD PARTIES ASSOCIATED WITH myEHE AND THEIR
						RESPECTIVE AFFILIATES, DIRECTORS, OFFICERS, OWNERS, CONTRACTORS, HEALTH COACHES, EMPLOYEES, AGENTS,
						SUCCESSORS, AND ASSIGNS, FROM ANY LIABILITY ARISING FROM OR IN ANY WAY CONNECTED WITH THE SERVICES PROVIDED
						HEREUNDER OR FROM THE DATA DERIVED THEREFROM.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">DISCLAIMER OF WARRANTIES AND CONSEQUENTIAL DAMAGES</p>
					<p>
						EHE Health does not warrant that the Web Site will be error-free or that myEHE or the server that makes it
						available are free of viruses or other harmful components.
					</p>
					<p>
						You acknowledge that in connection with myEHE, information will be transmitted over local exchange,
						inter-exchange and Internet backbone carrier lines and through routers, switches and other devices owned,
						maintained and serviced by third party local exchange and long distance carriers, utilities, Internet
						service providers and others, all of which are beyond the control and jurisdiction of EHE Health and its
						suppliers. Accordingly, EHE Health assumes no liability for or relating to the delay, failure, interruption
						or corruption of any data or other information transmitted in connection with use of myEHE.
					</p>
					<p>
						WITHOUT LIMITING THE FOREGOING, EVERYTHING ON THE WEB SITE, INCLUDING ALL myEHE SERVICES, IS PROVIDED TO YOU
						"AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING, BUT NOT
						LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
						NON-INFRINGEMENT. EHE HEALTH AND ITS SUPPLIERS MAKE NO WARRANTIES ABOUT THE ACCURACY, RELIABILITY,
						COMPLETENESS OR TIMELINESS OF myEHE MATERIAL, SOFTWARE TEXT, GRAPHICS, AND LINKS OR myEHE SERVICES, OR ABOUT
						RESULTS TO BE OBTAINED FROM USING THE WEB SITE OR myEHE SERVICES. EHE HEALTH AND ITS SUPPLIERS MAKE NO
						WARRANTY THAT THE CONTENT CONTAINED ON THIS WEB SITE SATISFIES GOVERNMENTAL REGULATIONS REQUIRING DISCLOSURE
						OF INFORMATION ON PRESCRIPTION DRUG PRODUCTS.
					</p>
					<p>
						Please note that some jurisdictions may not allow the exclusion of implied warranties, so some of the above
						exclusions may not apply to you.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">LIMITATION OF LIABILITY</p>
					<p>
						IN NO EVENT SHALL EHE HEALTH, ITS AGENTS, HEALTH COACHES OR ANY THIRD PARTIES MENTIONED AT THE WEB SITE BE
						LIABLE FOR ANY COSTS, DAMAGES AND EXPENSES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, HEALTH PROBLEMS,
						INCIDENTAL AND CONSEQUENTIAL DAMAGES, LOST PROFITS OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS
						INTERRUPTION) RESULTING FROM THE USE OR INABILITY TO USE myEHE, OR THE CONTENT OF THE WEB SITE, THE ONLINE
						MEDICAL RECORD OR ANY OTHER WEB SITE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL
						THEORY, AND WHETHER OR NOT EHE HEALTH IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. EHE HEALTH SHALL BE
						LIABLE TO YOU ONLY FOR GROSS NEGLIGENCE OR WILLFUL MISCONDUCT AND ONLY TO THE EXTENT OF ACTUAL DAMAGES
						INCURRED BY YOU, NOT TO EXCEED U.S. $100.00 (ONE HUNDRED DOLLARS). BECAUSE SOME STATES AND COUNTRIES DO NOT
						ALLOW THE EXCLUSION OF LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATION
						MAY NOT APPLY TO YOU. REMEDIES UNDER THIS AGREEMENT ARE EXCLUSIVE AND ARE LIMITED TO THOSE EXPRESSLY
						PROVIDED FOR IN THESE TERMS AND CONDITIONS.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">INDEMNIFICATION</p>
					<p>
						You agree to defend, indemnify and hold EHE Health, its officers, directors, employees and agents, licensors
						and suppliers harmless from and against any claims, actions or demands, liabilities and settlements,
						including, without limitation, reasonable legal and accounting fees, resulting from, or alleged to result
						from, your use of myEHE in a manner that violates or is alleged to violate these Terms and Conditions. EHE
						Health shall provide notice to you promptly of any such claim, suit or proceeding and shall reasonably
						cooperate with you, at your expense, in your defense of any such claim, suit or proceeding. EHE Health
						reserves the right, at its sole expense, to assume the exclusive defense and control of any matter subject
						to indemnification by you, including any settlement agreement for a claim.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">SECURITY</p>
					<p>
						All information is protected through Transport Layer Security (TLS) software, a more secure version of
						Secure Socket Layer (SSL) certificates, used to establish an encrypted connection.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">APPLE AND ANDROID DEVICE USAGE</p>
					<p>
						The following terms apply when you use a mobile application obtained from either the Apple Store or Google
						Play (each an "App Distributor") to access the Web Site:
					</p>
					<ol type="a">
						<li>
							You acknowledge that the App Distributor has no obligation whatsoever to furnish any maintenance and
							support services with respect to the Web Site.
						</li>
						<li>
							In the event of any failure of the Web Site to conform to any applicable warranty, you may notify the
							applicable App Distributor, and the App Distributor, in accordance with its terms and policies, may refund
							the purchase price, if any, paid for the Web Site and to the maximum extent permitted by applicable law,
							the App Distributor will have no other warranty obligation whatsoever with respect to the Web Site.
						</li>
						<li>
							You represent and warrant that (i) you are not located in a country that is subject to a U.S. government
							embargo, or that has been designated by the U.S. government as a "terrorist supporting" country and (ii)
							you are not listed on any U.S. government list of prohibited or restricted parties.
						</li>
						<li>You must comply with applicable third-party terms of agreement when using the mobile application.</li>
						<li>
							The App Distributor and its subsidiaries are third party beneficiaries to these Terms and Conditions, and
							upon your agreement with these Terms and Conditions, the App Distributor will have the right (and will be
							deemed to have accepted the right) to enforce these Terms and Conditions against you as a third-party
							beneficiary of these Terms and Conditions.
						</li>
					</ol>
				</div>
				<div class="group">
					<p class="sub-title">TERMINATION</p>
					<p>
						You are free to stop using the Web Site at any time. EHE Health, reserves the right, in its sole discretion,
						to terminate your use of myEHE, or any other service of myEHE, if EHE Health reasonably believes that you
						have violated or acted inconsistently with the letter or spirit of these Terms and Conditions, or violated
						the rights of EHE Health or any third party, or for any other reason with or without notice to you. EHE
						Health will not be liable to you or any third party as a result of such modification or discontinuation.
					</p>
					<p>
						EHE Health and its Licensors own all proprietary rights to myEHE. EHE Health gives you a personal,
						revocable, non-assignable, and non-exclusive license to use myEHE. Upon the termination of these Terms and
						Conditions for any reason, you shall promptly cease all use of the Web Site, data or materials not otherwise
						validly in your possession or that are only available to you through or as a result of your access to the
						Web Site. Upon any termination or expiration of these Terms and Conditions for any reason, you shall purge
						from your files or electronic systems (i) any of the components of the Web Site that may have been
						installed, saved or available to you; and (ii) any site content, data or materials that are only available
						to you through or as a result of your access to the Web Site.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">SURVIVAL</p>
					<p>
						The provisions entitled "Indemnification" "Disclaimer of Warranties and Consequential Damages" and
						"Limitation of Liability" will survive termination of this agreement.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">FORCE MAJEURE</p>
					<p>
						EHE HEALTH SHALL NOT BE LIABLE FOR ANY LOSSES ARISING OUT OF THE DELAY OR INTERRUPTION OF OUR PERFORMANCES
						OF ANY OBLIGATIONS DUE TO ANY ACT OF GOD, ACT OF GOVERNMENTAL AUTHORITY, ACT OF PUBLIC ENEMY, WAR, SEVERE
						WEATHER CONDITIONS, FIRE, LABOR DIFFICULTIES OR SHORTAGES, CIVIL DISTURBANCES, INTERRUPTIONS OF POWER,
						SUPPLY OR COMMUNICATION OR ANY OTHER CAUSE BEYOND OUR CONTROL, INCLUDING ANY NATIONAL EMERGENCY DURING WHICH
						THE WORLDWIDE INTERNET IS NOT ACCESSIBLE ON A REGIONAL OR NATIONAL BASIS. AT OUR OPTION AND SOLE DISCRETION,
						WE MAY AGREE TO APPROPRIATE TERMS OF ADJUSTMENT.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">JURISDICTION AND CONSTRUCTION</p>
					<p>
						The exclusive jurisdiction for any dispute with EHE Health, or in any way relating to your use of myEHE
						("Legal Action"), resides in the state and federal courts of New York County, and you agree and expressly
						consent to the exercise of personal jurisdiction in the courts of the State of New York in connection with
						any such dispute, including any claim involving EHE Health, or its affiliates, subsidiaries, employees,
						contractors, officers, directors, telecommunications providers and content providers. Any Legal Action that
						is subject to the jurisdiction of federal courts shall be instituted in the United States District Court for
						the Southern District of New York. These Terms and Conditions and are governed by the internal substantive
						laws of the State of New York, without respect to its conflict of law principles.
					</p>
					<p>
						If any provision of these Terms and Conditions are found to be invalid by any court having competent
						jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of
						these Terms and Conditions, which shall remain in full force and effect. The parties hereto agree that any
						rule of construction to the effect of the ambiguities are to be resolved against the drafting party shall
						not be applied in the interpretation of these Terms and Conditions. To the extent that anything contained
						within the Terms and Conditions and the Web Site is in conflict or inconsistent with the Terms and
						Conditions, the Terms and Conditions shall prevail.
					</p>
					<p>
						Any cause of action you may have with respect to EHE Health must be commenced within one year after the
						claim or cause of action arises or such claim or cause of action is barred. To the extent permitted by
						applicable law, you and EHE Health agree that each may bring claims against the other only in your or its
						individual capacity and not as a plaintiff or class member in any purported class or representative
						proceeding.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">INTERNATIONAL USE</p>
					<p>
						The Web Site is intended for user located within the United States. EHE Health makes no representation that
						materials on the website are appropriate or available for use in other locations and accessing them from
						territories where their contents are illegal is prohibited. Those who choose to access this website from
						other locations do so on their own initiative and are responsible for compliance with local laws.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">WAIVER</p>
					<p>
						No waiver of these Terms and Conditions shall be deemed a further or continuing waiver of such term or
						condition or any other term or condition. No failure by EHE Health to exercise any power, right, privilege,
						or remedy under these Terms and Conditions, and no delay on our part in exercising any power, right,
						privilege or remedy under these Terms and Conditions, shall operate as a waiver of such power, right,
						privilege or remedy.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">COMPLETE AGREEMENT</p>
					<p>
						These Terms and Conditions constitute the entire agreement between you and EHE Health with respect to the
						use of myEHE and any content or service contained therein.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">NOTICE</p>
					<p>
						EHE Health may deliver notice to you under these Terms and Conditions by means of electronic mail, a general
						notice of EHE Health, or by written communication delivered by first class U.S. mail to your address on
						record in EHE Health's account information. You may give notice to EHE Health at any time via electronic
						mail to EHE Health or by letter delivered by first class postage prepaid U.S. mail or overnight courier to
						the following address:
					</p>
					<div class="address">
						<p>EHE Health</p>
						<p>600 Fifth Avenue, 5th Floor</p>
						<p>New York, New York 10020</p>
						<p>Phone: 212.332.3700</p>
						<p>Email: <a href="mailto:legal@ehe.health">legal&#64;ehe.health</a></p>
					</div>
				</div>
				<div class="group">
					<p class="sub-title">MISCELLANEOUS</p>
					<p></p>
				</div>

				<div class="group">
					<p class="sub-title"></p>
					<p>
						Nothing expressed or implied from the Terms and Conditions are intended to or shall be construed to give to
						any person other than the parties hereto any legal or equitable right, remedy or claim under or in respect
						to these Terms and Conditions.
					</p>
					<p>
						Paragraph headings are for convenience of reference only and shall not affect the interpretation of any
						provision of these Terms and Conditions.
					</p>
					<p>
						EHE Health is not an agent, fiduciary, trustee or other representative. You agree that no joint venture,
						partnership, employment or agency relationship exists between you and EHE Health or between your
						organization and EHE Health as a result of the Terms and Conditions of your use of the Web Site.
					</p>
					<p>
						The Terms and Conditions are for EHE Health's sole and exclusive benefit. You may not assign, transfer or
						delegate these Terms and Conditions or any part thereof without our prior written consent. We may freely
						transfer, assign or delegate all or any part of these Terms and Conditions, and any rights and duties
						hereunder. These Terms and Conditions will be binding upon and inure to the benefit of the heirs, successors
						and permitted assignees of the parties. Any assignment of delegation in violation of the foregoing shall be
						null and void.
					</p>
				</div>
				<div class="group">
					<p class="sub-title">ELECTRONIC SIGNATURE</p>
					<p>
						By using this website, you hereby acknowledge that you have received, reviewed, and understand these Terms
						and Conditions of EHE Health. You further acknowledge that you have been given an opportunity to ask
						questions about your evaluation and myEHE. By reading and accepting this Terms and Conditions you represent
						that: (i) You are 18 years of age or older and have the right to contract in your own name; (ii) You have
						read, understand and agree to the contents of this Terms and Conditions; (iii) You agree and voluntarily
						consent to participate in myEHE and to conduct this transaction by electronic means; (iv) you agree that we
						may call you at the contact information provided, including possibly using automated technology, text and
						recorded messages, unless you expressly opt out in accordance with these Terms and Conditions, and (v) this
						is your electronic signature. EHE Health and you hereby state that electronic signatures shall have the same
						force and effect as original signatures with respect to this Terms and Conditions.
					</p>
					<p>Furthermore, by using this website, you hereby acknowledge and consent to the following:</p>
					<ul>
						<li>You provide consent to your Health Coach and EHE Health to receive Coaching.</li>
						<li>You understand the benefits and risks of the use of virtual services.</li>
						<li>
							No potential benefits or specific results can be guaranteed from the use of the Coaching. Your condition
							may not be cured or improved, and in some cases, may get worse.
						</li>
						<li>
							You may refuse or withdraw from Coaching at any time, and that your refusal or withdrawal will not affect
							your ability to receive Coaching in the future. However, you understand that if you decline virtual
							services, you may have to travel to seek in-person services, if applicable.
						</li>
						<li>
							A variety of alternative methods of medical care may be available to you and you may choose one or more of
							these at any time. Alternatives include, but are not limited to, presentation to your primary care
							physician, the nearest urgent care facility or the nearest Emergency Department. You will be afforded an
							opportunity to discuss these alternatives with your Health Coach, if you so choose.
						</li>
						<li>
							You have a right to be informed of the parties who will be present during the virtual services, and you
							have the right to exclude anyone present at the remote site.
						</li>
						<li>EHE Health may use third-party vendors to provide Coaching or other related services.</li>
						<li>
							The provision of Coaching involves electronic communication of your personal information to Health Coaches
							who may be located in other states, and that the provision of Coaching could fail, causing a breach of
							your privacy of your personal, health or other information.
						</li>
						<li>
							It is your duty to provide your Health Coach with truthful, accurate and complete information, including
							all relevant information regarding health care that you may have received or may be receiving from other
							health care providers or outside of Coaching.
						</li>
						<li>
							If you are uncomfortable with receiving Coaching or the method in which Coaching services are provided,
							you should inform your Health Coach.
						</li>
						<li>
							Your Health Coach may determine that your condition is not suitable via virtual or may fail to respond to
							your request for a virtual service, and that you may need to seek health care services from a physician or
							other qualified licensed healthcare provider.
						</li>
						<li>In the event of an emergency, you should dial 911 to receive appropriate follow-up care.</li>
						<li>
							In the event of technology failure or your Health Coach determining you need to see another provider or
							make an in-person appointment, the Health Coach will provide you with next steps or follow-up information.
						</li>
						<li>
							Failure to comply with this terms and conditions and the consents you provided herein may result in
							termination of your ability to use the Web Site or receive Coaching.
						</li>
					</ul>
				</div>
				<div class="group">
					<br /><br /><br />
					<p>Last updated : December 5, 2024</p>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
